/**
 * Registro de iconos de AppIcon.
 *
 * Cada entrada es una función que importa el SFC del icono de forma dinámica.
 * Con webpack esto genera un chunk independiente por icono, de modo que cada
 * SVG solo se carga cuando realmente se usa.
 *
 * Para agregar un icono:
 *   1. Crear src/components/UI/icons/NombreIcono.vue (un <svg> con viewBox 0 0 24 24)
 *   2. Agregar la entrada aquí con el nombre público que se usará en <AppIcon icon="...">.
 */
const icons = {
  edit: () => import('./EditIcon.vue'),
  delete: () => import('./DeleteIcon.vue'),
  close: () => import('./CloseIcon.vue'),
  add: () => import('./AddIcon.vue'),
  check: () => import('./CheckIcon.vue'),
  search: () => import('./SearchIcon.vue'),
  'chevron-left': () => import('./ChevronLeftIcon.vue'),
  'chevron-right': () => import('./ChevronRightIcon.vue'),
  'chevron-up': () => import('./ChevronUpIcon.vue'),
  'chevron-down': () => import('./ChevronDownIcon.vue'),
  visibility: () => import('./VisibilityIcon.vue'),
  'content-copy': () => import('./ContentCopyIcon.vue')
}

export default icons
